import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WfProcessDto} from "../../../model/dto/entity/wf-process.dto";
import {UmUserService} from "../../../../um/service/api/um-user.service";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationProviderGeneric
} from "../../../../../core/shared/navigation/impl/mvs-object-navigation-provider-generic";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsFormFieldOutputBaseComponent
} from "../../../../../core/shared/form/field/output/mvs-form-field-output-base.component";
import {ObjectTypeService} from "../../../../../core/cc/service/api/object-type.service";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {AlphaUseCase, AlphaUseCaseType} from "../../../../../core/shared/decorators";

@AlphaUseCase({type: AlphaUseCaseType.COMPONENT, usedIn: {module: "Core-Forms"}, description: "Used as an output field in widget layout configuration"})

@Component({
    selector: 'wf-process-output-field',
    templateUrl: './wf-process-output-field.component.html',
    standalone: false
})
export class WfProcessOutputFieldComponent extends MvsFormFieldOutputBaseComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() dtoList: DtoList;
    processList: WfProcessDto[];
    userName: string = '';


    constructor(protected userService: UmUserService, protected navigationService: MvsObjectNavigationService, protected objectService: ObjectTypeService, protected coreService: MvsCoreService) {
        super(navigationService,objectService,coreService);
    }

    ngOnInit(): void {
        this.navigationService.setNavigationProvider(new MvsObjectNavigationProviderGeneric());

        if (this.dtoList['activeProcess']) {
            this.processList = this.dtoList['activeProcess'] as WfProcessDto[];
        } else {
            this.processList = this.dtoList.entries as WfProcessDto[];
        }

    }

    openTicketDrawer(processId: number) {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry("wf.WfProcess", processId, null, "Process", null, null, MvsObjectNavigationActionEnum.any);
        this.navigationService.navigateTo(mvsObjectNavigationEntry, 'bottom');
    }

    getUserByOid(userOid: string) {
        // this.userService.getUserByOid(userOid).subscribe((res:UmUserDto) => {
        //     this.userName = res?.firstName + ' ' + res?.lastName;
        // })
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

}
